import React from 'react';
import { cn } from '../../utils/cn';

/**
 * การ์ดหนึ่งส่วนของหน้ารายละเอียด/แก้ไข — หน้าตาเดียวกับการ์ดของ MaintenanceViewPage
 * (bg-white rounded-lg shadow p-6 · หัวข้อ text-lg + ไอคอนสี primary)
 */
export interface DetailSectionProps {
  title: React.ReactNode;
  icon?: React.ReactNode;
  /** ปุ่ม/ลิงก์ด้านขวาของหัวการ์ด (เช่น "ดูทั้งหมด") */
  actions?: React.ReactNode;
  /** คำอธิบายใต้หัวข้อ */
  description?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** padding ของเนื้อหา (ตารางชิดขอบใช้ false) */
  padded?: boolean;
  testId?: string;
}

export const DetailSection: React.FC<DetailSectionProps> = ({
  title, icon, actions, description, children, className, padded = true, testId,
}) => (
  <section className={cn('bg-white rounded-lg shadow', className)} data-testid={testId}>
    <div className={cn('flex flex-wrap items-start justify-between gap-2', padded ? 'px-4 pt-4 sm:px-6 sm:pt-6' : 'px-4 py-4 sm:px-6 border-b border-secondary-100')}>
      <div className="min-w-0">
        <h2 className="text-lg font-semibold text-secondary-900 flex items-center gap-2">
          {icon && <span className="text-primary-600 flex-shrink-0 inline-flex">{icon}</span>}
          <span className="min-w-0 [overflow-wrap:anywhere]">{title}</span>
        </h2>
        {description && <p className="mt-1 text-xs text-secondary-500">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
    <div className={padded ? 'px-4 pb-4 pt-4 sm:px-6 sm:pb-6' : ''}>{children}</div>
  </section>
);

export default DetailSection;
